import { render, staticRenderFns } from "./DescargasActividad.vue?vue&type=template&id=4244b685&"
import script from "./DescargasActividad.vue?vue&type=script&lang=ts&"
export * from "./DescargasActividad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports